import { useEffect, useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { Box } from '@mui/material';

import MuiTextField from 'components/Form/MuiTextField';
import { DateBoundTimePicker } from 'components/TimePicker/DateBoundTimePicker';
import { coercePickerDate } from 'utils/timePickerBridge';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import MuiRadioGroup from './components/MuiRadioGroup';
import RowContentDialysis from './components/RowContent';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
}

const DialysisInfo = (props: Props) => {
  const { disabled, register, getValues, setValue, watch } = props;

  const contents = [
    {
      label: '투석일',
      element: (
        <Form.MuiTextField
          required={false}
          type="date"
          disabled={disabled}
          {...register('date')}
          sx={{ marginRight: '10px' }}
        />
      ),
    },
    {
      label: '투석시간',
      element: (
        <DateBoundTimePicker
          disabled={disabled}
          value={coercePickerDate(watch('time')) || null}
          onChange={v => setValue('time', v)}
          placeholder="00:00"
          usePortal={false}
        />
      ),
    },
    {
      label: '투석기',
      element: (
        <Form.MuiTextField
          {...register('dialyzer')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '투석기계',
      element: (
        <Form.MuiTextField
          {...register('dialysis_machine')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '투석실 내원경로',
      element: (
        <Box display="flex">
          <Form.MuiRadioGroup
            disabled={disabled}
            i18nKey="DIALYSIS.DIALYSIS_INFO.ROUTE"
            values={[1, 2, 3, 0]}
            defaultValue={getValues('visiting_route')}
            onChange={v => {
              setValue('visiting_route', v);
            }}
            width="80px"
          />
          <Form.MuiTextField
            {...register('visiting_route_etc')}
            placeholder="직접 입력"
            fullWidth={false}
            required={false}
            disabled={disabled}
          />
        </Box>
      ),
    },
    {
      label: '투석액',
      element: (
        <Form.MuiTextField
          {...register('dialysate')}
          required={false}
          disabled={disabled}
        />
      ),
    },
    {
      label: '혈관 종류',
      element: (
        <>
          <RowContainer xs={12}>
            <RowContentDialysis
              title={'혈관 종류'}
              titleRatio={1}
              childrenRatio={11}
            >
              <MuiRadioGroup
                disabled={disabled}
                i18nKey="DIALYSIS.DIALYSIS_INFO.BLOOD_VESSEL"
                values={[1, 2, 3, 4, 5, 6, 0]}
                defaultValue={getValues('vascular_access')}
                onChange={v => {
                  setValue('vascular_access', v);
                }}
                width="80px"
              />
              <Form.MuiTextField
                {...register('vascular_access_etc')}
                placeholder="직접 입력"
                fullWidth={false}
                required={false}
                disabled={disabled}
              />
            </RowContentDialysis>
          </RowContainer>
        </>
      ),
    },
    {
      label: '시작간호사',
      element: (
        <>
          <RowContainer xs={12}>
            <RowContent title={'시작간호사'} titleRatio={1} childrenRatio={5}>
              <Form.MuiTextField
                {...register('starting_nurse')}
                required={false}
                disabled={disabled}
              />
            </RowContent>
            <RowContent title={'종료간호사'} titleRatio={1} childrenRatio={5}>
              <Form.MuiTextField
                {...register('ending_nurse')}
                required={false}
                disabled={disabled}
              />
            </RowContent>
          </RowContainer>
        </>
      ),
    },
  ];
  return (
    <>
      <SectionTitle title="투석 정보" />
      <RowContainer xs={12}>
        {contents.map(({ label, element }) => {
          if (label === '혈관 종류' || label === '시작간호사') {
            return <>{element}</>;
          }

          return (
            <>
              <RowContent
                key={label}
                title={label}
                titleRatio={1}
                childrenRatio={5}
              >
                {element}
              </RowContent>
            </>
          );
        })}
      </RowContainer>
    </>
  );
};

export default DialysisInfo;
